import { render } from "./professionCourseDetail.vue?vue&type=template&id=7db73390&scoped=true"
import script from "./professionCourseDetail.vue?vue&type=script&lang=js"
export * from "./professionCourseDetail.vue?vue&type=script&lang=js"

import "./professionCourseDetail.vue?vue&type=style&index=0&id=7db73390&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db73390"]])

export default __exports__